/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PrescriptionResponseDto } from './PrescriptionResponseDto';
import {
    PrescriptionResponseDtoFromJSON,
    PrescriptionResponseDtoFromJSONTyped,
    PrescriptionResponseDtoToJSON,
    PrescriptionResponseDtoToJSONTyped,
} from './PrescriptionResponseDto';

/**
 * 
 * @export
 * @interface GetPrescriptionsResponseDto
 */
export interface GetPrescriptionsResponseDto {
    /**
     * 
     * @type {number}
     * @memberof GetPrescriptionsResponseDto
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof GetPrescriptionsResponseDto
     */
    pageSize: number;
    /**
     * 
     * @type {number}
     * @memberof GetPrescriptionsResponseDto
     */
    total: number;
    /**
     * 
     * @type {string}
     * @memberof GetPrescriptionsResponseDto
     */
    nextPageToken?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetPrescriptionsResponseDto
     */
    hasMore?: boolean;
    /**
     * List of prescriptions
     * @type {Array<PrescriptionResponseDto>}
     * @memberof GetPrescriptionsResponseDto
     */
    items: Array<PrescriptionResponseDto>;
}

/**
 * Check if a given object implements the GetPrescriptionsResponseDto interface.
 */
export function instanceOfGetPrescriptionsResponseDto(value: object): value is GetPrescriptionsResponseDto {
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('pageSize' in value) || value['pageSize'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function GetPrescriptionsResponseDtoFromJSON(json: any): GetPrescriptionsResponseDto {
    return GetPrescriptionsResponseDtoFromJSONTyped(json, false);
}

export function GetPrescriptionsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPrescriptionsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'page': json['page'],
        'pageSize': json['pageSize'],
        'total': json['total'],
        'nextPageToken': json['nextPageToken'] == null ? undefined : json['nextPageToken'],
        'hasMore': json['hasMore'] == null ? undefined : json['hasMore'],
        'items': ((json['items'] as Array<any>).map(PrescriptionResponseDtoFromJSON)),
    };
}

export function GetPrescriptionsResponseDtoToJSON(json: any): GetPrescriptionsResponseDto {
    return GetPrescriptionsResponseDtoToJSONTyped(json, false);
}

export function GetPrescriptionsResponseDtoToJSONTyped(value?: GetPrescriptionsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'page': value['page'],
        'pageSize': value['pageSize'],
        'total': value['total'],
        'nextPageToken': value['nextPageToken'],
        'hasMore': value['hasMore'],
        'items': ((value['items'] as Array<any>).map(PrescriptionResponseDtoToJSON)),
    };
}

